module.exports = __webpack_public_path__ + "fonts/font.e830c989.woff2";